import { Language } from './base';

const pdash = () => import('../translations/pdash/nl-NL.json');
const webActivities = () => import('../translations/web-activities/nl-NL.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/nl-NL.json');

export default new Language({
    code: 'nl-NL',
    locale: 'nl',
    localName: 'Nederlands',
    englishName: 'Dutch',
    territory: 'NL',
    timezones: ['Europe/Amsterdam'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
